import styled from 'styled-components';

export const StyledIcon = styled.div`
  padding-right: 12px;

  & svg {
    margin-left: 2px;
    color: #787f88;
    font-size: 12px;
    stroke: #787f88;
    stroke-width: 2px;
    transform: translateY(2px);
  }
`;
export const StyledDropdownIcon = styled.span`
  .MuiIconButton-root:hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }
`;
